import { isBoundaryExportMove } from "../../util/featureFlags";
import { NavItem } from "./NavSection";

export const generateFarmSettingsItems = (farmId: string): NavItem[] => [
  {
    name: isBoundaryExportMove ? "Field List" : "View fields",
    icon: "fa-frame",
    pathname: `/farm/${farmId}/field-map`,
  },
  {
    name: "Farm details",
    icon: "fa-circle-info",
    pathname: `/farm/${farmId}/farm-details`,
  },
];

export const adminSettingsItems: NavItem[] = [
  {
    name: "Farm list",
    icon: "fa-lock",
    pathname: "/admin/",
  },
];

export const userProfileItems: NavItem[] = [
  {
    name: "My profile",
    icon: "fa-circle-user",
    pathname: "/user-profile",
  },
  {
    name: "Sign out",
    icon: "fa-arrow-right-from-bracket",
    pathname: "/logout",
  },
];
